import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout')
const ExternalLayout = () => import('@/layouts/ExternalLayout')
const ExportData = () => import('@/views/dash/Clients/ExportData')
const ApiAmount = () => import('@/views/landing/ApiAmount')
const Redirect = () => import('@/views/utils/Redirect.vue')

export default [
    {
        path: '/clientes',
        component: DashLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkPermission],
        children: [{path: 'exportar', name: 'clients.export', component: ExportData, meta: {title: 'Exportar clientes'}}],
    },
    {
        path: '/custos-api-oficial',
        component: ExternalLayout,
        children: [{path: '', name: 'landing.apiAmount', component: ApiAmount, meta: {title: 'Custos API oficial'}}],
    },
    {
        path: '/classificacoes/clientes',
        component: Redirect,
        name: 'redirect.classification',
        beforeEnter: (to, from, next) => {
            window.location.href = `/v3/classificacoes/clientes`
        }
    },
    {
        path: '/classificacoes/status',
        component: Redirect,
        name: 'redirect.classification.status',
        beforeEnter: (to, from, next) => {
            window.location.href = `/v3/classificacoes/status`
        }
    },
    {
        path: '/planos',
        component: Redirect,
        name: 'redirect.service.plans',
        beforeEnter: (to, from, next) => {
            window.location.href = `/v3/planos`
        }
    },
]